import { EventParams } from '../interfaces';

enum Message {
	Log = 'log-message',
	Badge = 'widget-badge'
}

function createMessage<Data>(type: Message, dataKey: string = 'data') {
	return (data?: Data) => {
		try {
			// window.parent.postMessage(
			// 	JSON.stringify({
			// 		messageType: type,
			// 		...Object.assign({}, { [dataKey]: data })
			// 	}),
			// 	'*'
			// );
		} catch (ex) {
			console.log(ex);
		}
	};
}

export const log = createMessage<EventParams>(Message.Log, 'log');
export const sendBadgeCounter = createMessage<number>(Message.Badge);
